import { Box, Typography } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import useStyles from './_styles'
import { TransmissionsAutoCalculatedProps } from './_props'
import { CrossPurpleIcon } from '../../../assets/icons/icons'

export default function TransmissionsAutoCalculated({ value, execName }: TransmissionsAutoCalculatedProps) {
    const classes = useStyles()
    const displayValue =
        value === undefined || value === null || (typeof value === 'number' && isNaN(value)) ? '—' : String(value)

    return (
        <Box className={classes.autoCalculatedContainer}>
            <Box className={classes.autoCalculatedContent}>
                <CrossPurpleIcon />
                <Box className={classes.autoCalculatedText}>
                    <Typography className={classes.autoCalculatedValue}>{displayValue}</Typography>
                    <Typography className={classes.autoCalculatedSubtitle}>
                        Réponse automatique du système (non modifiable)
                    </Typography>
                </Box>
                <LockIcon className={classes.autoCalculatedLockIcon} />
            </Box>
        </Box>
    )
}
